require('./cardGenericConfirmationStep.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ commons
const { FormattedText } = require('core/i18n').i18n;

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class CardGenericConfirmationStep extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { operativeName, immCard } = this.props;
        const cardBeneficiaryName = immCard.get('beneficiaryName');
        const cardAlias = immCard.getIn([ 'alias', 'current' ]);
        const cardNumber = immCard.get('number');

        return (
            <div className="card-generic-confirmation-step">
                <div className="card-generic-confirmation-step__title wizard-step--vertical__title print-title">
                    <FormattedText value="cardGenericConfirmationStep-title" />
                </div>
                <div className="card-generic-confirmation-step__subtitle wizard-step--vertical__sub-title no-print-out">
                    <FormattedText value="cardGenericConfirmationStep-subtitle" />
                </div>
                <div className="card-generic-confirmation-step__body">
                    <BlockInfo>
                        <p>
                            <FormattedText
                                className="card-generic-confirmation-step__confirmation-script"
                                value="cardGenericConfirmationStep-confirmationScriptPart1"
                            />
                            <span className="card-generic-confirmation-step__confirmation-script card-generic-confirmation-step__confirmation-script--strong">{cardBeneficiaryName}</span>
                        </p>
                        <br className="no-print-out"/>
                        <p>
                            <FormattedText
                                className="card-generic-confirmation-step__confirmation-script"
                                value="cardGenericConfirmationStep-confirmationScriptPart2"
                                injectedStrings={[ operativeName, cardAlias, cardNumber ]}
                            />
                        </p>
                        <br className="no-print-out"/>
                        <p className="no-print-out">
                            <FormattedText
                                className="card-generic-confirmation-step__confirmation-script"
                                value="cardGenericConfirmationStep-confirmationScriptPart3"
                                injectedStrings={[ cardBeneficiaryName ]}
                            />
                        </p>
                    </BlockInfo>
                </div>
            </div>
        );
    }
}

CardGenericConfirmationStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    operativeName: PropTypes.string.isRequired,
}

module.exports = CardGenericConfirmationStep;
